<template>
	<div class="content-box-wrapper logged-in-sidebar">
		<div class="content-box-header bg-white">
			<div class="row align-items-center">
				<div class="col-auto margin-bottom-md-0">
					<span class="user-avatar">{{ userEmailFirstLetter }}</span>
				</div>
				<div class="col">
					<p class="mb-0 user-email">{{ email }}</p>
				</div>
				<div class="col-auto d-md-none">
					<a
						href="#"
						class="d-inline-block"
						@click.prevent="
							sidebarInfoToggled = !sidebarInfoToggled
						"
						><Icon
							class="icon-17 icon-lg"
							:icon="'dots-horizontal-triple'"
					/></a>
				</div>
			</div>
		</div>
		<div
			class="content-box-padding bg-image bg-image-1 logged-in-sidebar-info"
			:class="{
				'd-none d-md-block': !sidebarInfoToggled,
				'd-block': sidebarInfoToggled
			}"
		>
			<div class="margin-top-xs-1" v-if="messages.length">
				<Message
					v-for="message in messages"
					:text="message.text"
					:type="message.type"
					:key="message.text"
				/>
			</div>

			<div class="">
				<div class="margin-bottom-xs-2">
					<p class="label label--white">Din grupp</p>
					<p
						class="value value--large text-white"
						v-html="user.group_name"
					></p>
				</div>
				<div class="margin-bottom-xs-2">
					<p class="description text-white">
						Bjud in andra till din grupp genom att be dem ange denna
						gruppkod vid registrering.
					</p>
					<input
						type="text"
						class="input-text text-white"
						:value="user.group_key"
						disabled
					/>
					<p class="description text-white">
						Eller skicka följande länk till dem och be dem att skapa
						ett konto.
					</p>
					<input
						type="text"
						class="input-text text-white text-small"
						:value="groupInivtationLink"
						disabled
					/>
				</div>
			</div>

			<div class="row">
				<div class="col-6">
					<!--
					<a href="#" @click.prevent="doLogout" class="text-white"
						>Inställningar</a
					>
                    -->
				</div>
				<div class="col-6 text-right">
					<a
						href="#"
						@click.prevent="doLogout"
						class="pem-btn pem-btn-secondary pem-btn-sm"
						>Logga ut</a
					>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Message from "./../partials/Message.vue";
import Icon from "./../partials/Icon.vue";
export default {
	name: "LoggedInSidebar",
	props: [],
	components: { Message, Icon },
	computed: {
		email() {
			return this.$store.state.user.email;
		},
		messages() {
			return this.$store.state.messages.sidebar;
		},
		userEmailFirstLetter() {
			return this.$store.state.user.email[0];
		},
		user() {
			return this.$store.state.user;
		},
		groupInivtationLink() {
			var url = window.location.href;
			return url + "?show=signup&group_key=" + this.user.group_key;
		}
	},
	data() {
		return {
			sidebarInfoToggled: false
		};
	},
	methods: {
		doLogout() {
			this.$store.dispatch("doLogout");
		}
	},
	mounted() {}
};
</script>